import { useCallback } from 'react';
import { routes } from 'routes/routes';
import { Button, Flex, Icon, Modal } from 'ui';
import { useReadAllNotificationsMutation } from '../queries';

const NotificationsNav = () => {
  const [modal, contextHolder] = Modal.useModal();
  const { mutate: readAllNotifications } = useReadAllNotificationsMutation();

  const handleMarkAllAsRead = useCallback(() => {
    modal.confirm({
      content: 'Are you sure you want to mark all notifications as read?',
      okText: 'Mark all as read',
      onOk() {
        readAllNotifications({});
      },
      title: 'Mark all as read',
    });
  }, [modal, readAllNotifications]);

  return (
    <Flex gap="ms">
      {contextHolder}
      <Button icon={<Icon icon="check-line" />} onClick={handleMarkAllAsRead}>
        Mark all as read
      </Button>
      <Button icon={<Icon icon="settings-5-line" />} navigate={{ to: routes.user.settings }}>
        Notifications Settings
      </Button>
    </Flex>
  );
};

export default NotificationsNav;
